import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Fragment, useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
//import Context from "@ckeditor/ckeditor5-core/src/context";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
//import Essentials from "@ckeditor/ckeditor5-essentials/src/essentials";
//-----------------------------------------------------------------------------------------
import FileSystem from "src/components/common/fileSystem";
import TransitionWidthHeight from "src/components/common/TransitionWidthHeight";
import UserInfo from "src/components/common/userInfo";
import Thumbnail from "src/components/common/thumbnail";
import { WorkLogContent } from "src/components/workLogs/workLogContent";
import { useMyStore } from "src/components/main/mainStore";
import {
    locatingApproval, scanningApproval, numberReducer, myAxios, 
    MyFormData, defaultEmptyDateTime, scroll,
    additionalJobTagApproverEmails, getTimeStamp
} from "src/components/common/functions";
//-----------------------------------------------------------------------------------------
export default function WorkLogs({
    title, 
    totalHours, 
    
    projectId, 

    workInstruction, 
    
    setWorkInstructions, 

    setCurrentWorkInstruction, 
    workInstructionId, 

    currentWorkLogs, 
    setCurrentWorkLogs, 

    loadingWorkLogs
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    // projectName, projectHashKey, workInstructionHashKey, workLogHashKey, userName, labor, startTime, endTime, 
    // emailTime, thumbnail, laborCategory, truckNumber, perDiem, workLogSubmitTime, workLogStatus, isFinished, onCalendar
    // projectManagerEmail, supervisorEmail, decisionNotes, pipeline, 
    //-----------------------------------------------------------------------------------------
    const history = useHistory();
    const location = useLocation();
    const workLogId = location.pathname.split("/")[6];
    const workLogFormId = location.pathname.split("/")[7];
    const workLogSubFormId = location.pathname.split("/")[8];
    const [comments, setComments] = useState("");
    const items = useMyStore(state => state.approvals);
    const setItems = useMyStore(state => state.setApprovals);
    const approval = async decision => {
        if(window.confirm(`are you sure to ${decision.toLowerCase()} this Work Log?`)){
            const formData = new MyFormData();
            formData.append("workLogHashKey", workLogId);
            formData.append("decision", decision);
            formData.append("comments", comments);
            //----------------------------------------------------
            setShowLoader(true);
            const res = await myAxios("approvals/approval.php", formData);
            setShowLoader(false);
            if(!res) return;
            //----------------------------------------------------
            setComments("");
            setCurrentWorkLogs(currentWorkLogs.map(w => (
                {
                    ...w, 
                    workLogStatus: workLogId === w.workLogHashKey?decision:w.workLogStatus, 
                    decisionNotes: workLogId === w.workLogHashKey?comments:w.decisionNotes
                }
            )));
            setItems(items.data.filter(item => item.workLogHashKey !== workLogId), getTimeStamp());
            history.replace(`/Projects/${projectId}/${title}/${workInstructionId}`)
            //history.push(`/Tasks`);
        }
    }
    useEffect(() => {
        const workLogId = location.pathname.split("/")[6];
        scroll(workLogId);
    }, [location]);
    //-----------------------------------------------------------------------------------------
    return (
        loadingWorkLogs?<div className = "cssLoading">Loading...</div>:
        currentWorkLogs.length === 0?<div className = "cssLoading">No one Scheduled Yet</div>:
        <div className = "table-responsive">
        <table className = "table">
            <thead>
            <tr>
                <th></th>
                <th>Creation Date</th>
                <th>Technician</th>
                <th>Category</th>
                <th>Truck Number</th>
                <th>Per Diem</th>
                <th>Submission Date</th>
                <th>Status</th>
                <th>Finished</th>
                <th>Work Hours</th>
                <th>Travel Hours</th>
                <th>Total Hours</th>
                <th>Calendar</th>
                <th>Text Status</th>
            </tr>
            </thead>
            <tbody>
            {currentWorkLogs.map((workLog, workLogIndex) => (
            <Fragment key = {workLogIndex}>
                <tr
                    id = {workLogId}
                    className = "pointer"
                    style = {{background: workLog.workLogVoid === "yes"?"grey":""}}
                    onClick = {e => {
                        const userinfo = e.currentTarget.children[2].children[0];
                        if(e.target === userinfo) return;
                        const onCalendar = e.currentTarget.children[8].children[0];
                        if(e.target === onCalendar) return;
                        const myModal = document.getElementsByClassName("myModal");
                        if(myModal[0] && myModal[0].contains(e.target)) return;

                        if(workLogId !== workLog.workLogHashKey){
                            history.push(`/Projects/${projectId}/${title}/${workInstructionId}/WorkLogs/${workLog.workLogHashKey}`);
                            scroll(workLogId);
                        }else{
                            history.push(`/Projects/${projectId}/${title}/${workInstructionId}`);
                            scroll(workInstructionId);
                        }
                    }}
                >
                    <td className = {workLogId === workLog.workLogHashKey?"showMinus":"showPlus"}></td>
                    <td>{workLog.emailTime}</td>
                    <td id = {workLog.labor}>
                        <Thumbnail
                            value = {workLog.thumbnail}
                            side = {75}
                        />
                        <UserInfo
                            name = {workLog.userName}
                            email = {workLog.labor}
                        />
                        {workLog.labor === workInstruction.teamLead?<span className = "badge badge-primary mx-3">JSA Initiator</span>:null}
                    </td>
                    <td>{workLog.laborCategory}</td>
                    <td>{workLog.truckNumber}</td>
                    <td>{workLog.perDiem || "No"}</td>
                    <td>{workLog.workLogSubmitTime === defaultEmptyDateTime?"":workLog.workLogSubmitTime}</td>
                    <td>{workLog.workLogStatus}</td>
                    <td>{workLog.isFinished === "1"?"Yes":(workLog.isFinished === "2"?"No":"Unknown")}</td>
                    <td>
                    {(totalHours !== null && totalHours.filter(t => t.workLogHashKey === workLog.workLogHashKey && t.jobTagSubmitTime !== defaultEmptyDateTime).length?
                    Math.round(totalHours.filter(t => t.workLogHashKey === workLog.workLogHashKey && t.jobTagSubmitTime !== defaultEmptyDateTime)
                    .map(d => (new Date(d.workEndTime.replace(/-/g, "/")) - new Date(d.workStartTime.replace(/-/g, "/"))) / 3600000)
                    .reduce(numberReducer, 0) * 100) / 100:0)}
                    </td>
                    <td>
                    {(totalHours !== null && totalHours.filter(t => t.workLogHashKey === workLog.workLogHashKey && t.jobTagSubmitTime !== defaultEmptyDateTime).length?
                    Math.round(totalHours.filter(t => t.workLogHashKey === workLog.workLogHashKey && t.jobTagSubmitTime !== defaultEmptyDateTime)
                    .map(d => ((new Date(d.workStartTime.replace(/-/g, "/")) - new Date(d.travelStartTime.replace(/-/g, "/"))) + (new Date(d.travelEndTime.replace(/-/g, "/")) - new Date(d.workEndTime.replace(/-/g, "/")))) / 3600000)
                    .reduce(numberReducer, 0) * 100) / 100:0)}
                    </td>
                    <td>
                    {(totalHours !== null && totalHours.filter(t => t.workLogHashKey === workLog.workLogHashKey && t.jobTagSubmitTime !== defaultEmptyDateTime).length?
                    Math.round(totalHours.filter(t => t.workLogHashKey === workLog.workLogHashKey && t.jobTagSubmitTime !== defaultEmptyDateTime)
                    .map(d => (new Date(d.travelEndTime.replace(/-/g, "/")) - new Date(d.travelStartTime.replace(/-/g, "/"))) / 3600000)
                    .reduce(numberReducer, 0) * 100) / 100:0)}
                    </td>
                    <td id = {workLog.workLogHashKey}>{workLog.onCalendar === "No"?<span className = "btn btn-primary" onClick = {async() => {
                        const formData = new MyFormData();
                        formData.append("workLogHashKey", workLog.workLogHashKey);
                        //----------------------------------------------------
                        setShowLoader(true);
                        const res = await myAxios("workInstructions/addGoogleAttendee.php", formData);
                        setShowLoader(false);
                        if(!res) return;
                        //----------------------------------------------------
                        setCurrentWorkInstruction(null);
                        history.push(`/Projects/${projectId}`);
                    }}>Add</span>:<>✅</>}</td>
                    <td id = {workLog.MessageSid}>{["failed", "undelivered"].includes(workLog.textStatus)?<span className = "btn btn-primary" onClick = {async() => {
                        if(!window.confirm("If the phone number is not updated, it may probably failed again. Are you sure to proceed?")) return;
                        const formData = new MyFormData();
                        formData.append("workLogHashKey", workLog.workLogHashKey);
                        //----------------------------------------------------
                        setShowLoader(true);
                        const res = await myAxios("workInstructions/resendText.php", formData);
                        setShowLoader(false);
                        if(!res) return;
                        //----------------------------------------------------
                        setCurrentWorkInstruction(null);
                        history.push(`/Projects/${projectId}`);
                    }}>Send</span>:workLog.textStatus}</td>
                </tr>
                <tr>
                    <td className = "noborder" colSpan = {100}>
                    <TransitionWidthHeight
                        In = {workLogId === workLog.workLogHashKey}
                        classNames = {"cssTDTransition"}
                    >
                        <div className = "border rounded p-2">
                            <FileSystem
                                className = "mb-3"
                                fileSystem = {[{title: "Work Log Attachments"}]}
                                item = {workLog}
                                filesKey = "workLogFiles"
                                singleFolderId = "laborFolderId"
                                readOnly = {true}
                            />
                            {user.projects !== "readOnly"?
                            <WorkLogContent
                                {...workLog}
                                //setCurrentWorkLog = {setCurrentWorkLog}
                                setWorkLogs = {setCurrentWorkLogs} 
                                workLogs = {currentWorkLogs}
                                //---------
                                history = {history}
                                id = {workLogId}
                                
                                adminLink = {`/Projects/${projectId}/${title}/${workInstructionId}/WorkLogs`}
                                setWorkInstructions = {setWorkInstructions}

                                formName = {workLogFormId}
                                subFormName = {workLogSubFormId}
                                //---------
                                // setShowForms = {setShowForms}
                                //---------
                            />
                            :<></>}
                            {(workLog.workLogStatus === "Approved" || workLog.workLogStatus === "Rejected")?
                            <>
                            {workLog.workLogStatus === "Rejected"?
                            <div className = "h5 my-2 text-danger">{workLog.projectManager} rejected this work log.</div>
                            :null}
                            {workLog.workLogStatus === "Approved"?
                            <div className = " h5 my-2 text-success">{workLog.projectManager} approved this work log.</div>
                            :null}
                            <div className = "h5 mb-2">Approver Comments</div>
                            <div className = "rounded border p-3">
                                {/*Reading mode*/}
                                <CKEditor
                                    editor = {ClassicEditor}
                                    onReady = {e => {
                                        if(e && e.sourceElement.nextElementSibling){
                                            e.sourceElement.nextElementSibling.children[1].style.display = "none";
                                            e.sourceElement.nextElementSibling.children[2].children[0].style.border = "none";
                                        }
                                    }}
                                    config = {{
                                        toolbar: []
                                    }}
                                    disabled = {true} 
                                    data = {workLog.decisionNotes}
                                />
                            </div>
                            </>
                            :null}
                            {(
                                workLog.projectManagerEmail === user.email || workLog.supervisorEmail === user.email || 
                                (locatingApproval.includes(user.email) && workLog.pipeline === "Locating Project") || 
                                (scanningApproval.includes(user.email) && workLog.pipeline === "GPR Concrete Scanning and Coring Project")
                            )
                            && workLog.workLogStatus === "Submitted"?
                            <>
                                <div className = "h5 mt-5 mb-2">Approver Comments</div>
                                {/*Editing mode*/}
                                <CKEditor
                                    editor = {ClassicEditor}
                                    config = {{
                                            toolbar: [
                                            "selectAll", "undo", "redo", "bold", "italic", 
                                            "heading", "link", "numberedList", "bulletedList", "insertTable", 
                                            "tableColumn", "tableRow", "mergeTableCells"
                                        ]
                                    }}
                                    data = {comments}
                                    onChange = {(e, editor) => {
                                        setComments(editor.getData()); 
                                    }}
                                />
                                <button type = "button" className = "btn btn-primary my-3 mr-3" onClick = {() => approval("Approved")}>Approve</button>
                                <button type = "button" className = "btn btn-danger my-3" onClick = {() => approval("Rejected")}>Reject</button>
                            </>:
                            null
                            }
                            {additionalJobTagApproverEmails.includes(user.email) && (workLog.workLogStatus === "Approved" || workLog.workLogStatus === "Rejected")?
                            <>
                            <div className = "h5 mt-5 mb-2">Current Approver Comments</div>
                            <div className = "rounded border p-3">
                                <CKEditor
                                    editor = {ClassicEditor}
                                    onReady = {e => {
                                        if(e && e.sourceElement.nextElementSibling){
                                            e.sourceElement.nextElementSibling.children[1].style.display = "none";
                                            e.sourceElement.nextElementSibling.children[2].children[0].style.border = "none";
                                        }
                                    }}
                                    config = {{
                                        toolbar: []
                                    }}
                                    disabled = {true} 
                                    data = {workLog.decisionNotes}
                                />
                            </div>
                            </>
                            :null}
                            {additionalJobTagApproverEmails.includes(user.email) && workLog.workLogStatus !== "Created"?
                            <>
                                <div className = "h5 mt-5 mb-2">Your Approver Comments (yours will overwrite current one)</div>
                                <CKEditor
                                    editor = {ClassicEditor}
                                    config = {{
                                            toolbar: [
                                            "selectAll", "undo", "redo", "bold", "italic", 
                                            "heading", "link", "numberedList", "bulletedList", "insertTable", 
                                            "tableColumn", "tableRow", "mergeTableCells"
                                        ]
                                    }}
                                    data = {comments}
                                    onChange = {(e, editor) => {
                                        setComments(editor.getData()); 
                                    }}
                                />
                                <button type = "button" className = "btn btn-danger my-3" onClick = {() => approval("Rejected")}>Reject</button>
                            </>:
                            null
                            }

                        </div>
                        </TransitionWidthHeight>
                    </td>
                </tr>
            </Fragment>
            ))
            }
            </tbody>
        </table>
        </div>
    )
}